import {Component} from "@angular/core";

@Component({
    selector: "wbo-login-podium",
    styleUrls: ["./login-podium.component.scss"],
    templateUrl: "./login-podium.component.html"
})
export class LoginPodiumComponent {
}
